/**
 * Arabic word context checkers
 */
import { isArabicChar } from '../../../char';

function arabicWordStartCheck(contextParams) {
  var char = contextParams.current;
  var prevChar = contextParams.get(-1);
  return (// ? arabic first char
    prevChar === null && isArabicChar(char) || // ? arabic char preceded with a non arabic char
    !isArabicChar(prevChar) && isArabicChar(char)
  );
}

function arabicWordEndCheck(contextParams) {
  var nextChar = contextParams.get(1);
  return (// ? last arabic char
    nextChar === null || // ? next char is not arabic
    !isArabicChar(nextChar)
  );
}

export { arabicWordStartCheck, arabicWordEndCheck };
export default {
  arabicWordStartCheck: arabicWordStartCheck,
  arabicWordEndCheck: arabicWordEndCheck
};